import React from 'react';
import Download from '../elements/download';
import Video from '../elements/video';

const v = require('../../../video/compressed.mp4');

interface Props {
    onDownload: (data?: any) => void;
    releases: any[];
};

const Intro = (props: Props) => {
    const { onDownload, releases } = props;

    return (
	<div className="section intro">
	    <h1>Peer-to-peer communication<br />
		over chats, docs<br />
		and handcrafted apps<br /></h1>

	    <Download onDownload={onDownload} items={releases} />

	    <Video src={v} />
	</div>
    );

};

export default Intro;